<template>
  <b-spinner
    :variant="variant"
    :small="small"
    :label="label"
    :class="spinnerClass"
  />
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    /**
     * Spinner size: 'sm' for small, default for normal size
     */
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['sm', 'default'].includes(value)
    },
    /**
     * Bootstrap variant for spinner color
     */
    variant: {
      type: String,
      default: 'primary'
    },
    /**
     * Accessibility label for screen readers
     */
    label: {
      type: String,
      default: 'Loading...'
    }
  },
  computed: {
    small() {
      return this.size === 'sm'
    },
    spinnerClass() {
      return {
        'loading-spinner': true,
        [`loading-spinner--${this.size}`]: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-spinner {
  &--sm {
    // Additional small size styling if needed
  }

  &--default {
    // Default size styling if needed
  }
}
</style>